import axios from "axios";
import { axiosHelper } from "../../helpers/test/axiosHelper";

const viajeModel = {
  unidad_id: "",
  chofer_id: "",
  cedis_id: "",
  descripcion: "",
  fecha_hora_salida: "2022-01-01 00:00:00",
  fecha_hora_regreso: "2022-01-01 00:00:00",
  status_id: 1,
};

const viajeExistModel = {
  unidad_id: "",
  viaje_id: "",
  chofer_id: "",
  operador_id: "",
  tripulantes: [],
  cedis_id: "",
  marchamo: "",
  cajas: 0,
  descripcion: "",
  fecha_hora_salida: "2022-01-01 00:00:00",
  fecha_hora_regreso: "2022-01-01 00:00:00",
  status: 1,
};
const checkModel = {
  viaje_id: "",
  guardia_id: "",
  monitorista_id: "",
  paro_motor: null,
  boton_panico: null,
  conectividad: null,
};
const tripulantesModel = {
  id_viaje: 0,
  tripulantes: [
    {
      tripulante_id: "",
    },
  ],
};

const ModelRutas = {
  viaje_id: 0,
  tiendas: [0],
};

const ModelRuta = {
  viaje_id: 0,
  tienda_id: 0,
};
const ModelBitacora = {
  id_viaje: "",
  id_monitorista: "",
  fecha: "",
  notas: "",
  id_status: 1,
};

export const useUnidades = () => {
  const getUnidadesFormatoSalida = async () => {
    let resp = await axiosHelper({ url: "unidades/programarSalida" });
    return resp;
  };
  const getNegocios = async () => {
    let resp = await axiosHelper({
      url: "negocios",
    });
    return resp;
  };
  const getCedisNegocios = async (id, cat_tipos_almacen_id = 1) => {
    let resp = await axiosHelper({
      url: "cedis/negocio/" + id + "/" + cat_tipos_almacen_id,
    });
    return resp;
  };
  const getCedisNegociosAll = async (id) => {
    let resp = await axiosHelper({
      url: "cedis/all/negocio/" + id,
    });
    return resp;
  };

  const getBitacoraViaje = async (id_viaje) => {
    let resp = await axiosHelper({ url: "bitacora/viaje/" + id_viaje });
    return resp;
  };
  const getBitacoras = async () => {
    let resp = await axiosHelper({ url: "bitacora/" });
    return resp;
  };

  const getBitacorasV2 = async (idNegocio, fechaI = null, fechaF = null) => {
    let url = "";
    if (fechaI && fechaF) {
      url = `v2/bitacora?idNegocio=${idNegocio}&fechaI=${fechaI}&fechaF=${fechaF}`
    } else {
      url = `v2/bitacora?idNegocio=${idNegocio}`
    }
    let resp = await axiosHelper({ url });
    return resp;
  };
  const getBitacoraAdministracion = async () => {
    let resp = await axiosHelper({ url: "logs/" });
    return resp;
  };
  const getUnidadesEnRuta = async () => {
    let resp = await axiosHelper({ url: "unidades/enRuta" });
    return resp;
  };
  const getTiendasViaje = async (viaje_id) => {
    let resp = await axiosHelper({
      url: "rutas/getRutasByViajeId/" + viaje_id,
    });
    //
    return resp;
  }; //pendiente a reivision
  const getCedi = async (cedi_id) => {
    let resp = await axiosHelper({
      url: "cedis/" + cedi_id,
    });
    return resp;
  };
  const getCedis = async () => {
    let resp = await axiosHelper({
      url: "cedis",
    });
    return resp;
  };
  const getChoferesCedisId = async (id_cedis) => {
    let resp = await axiosHelper({
      url: "choferes/cedis/" + id_cedis,
    });
    return resp;
  };
  const getChofer = async (id_chofer) => {
    let resp = await axiosHelper({
      url: "choferes/" + id_chofer,
    });
    return resp;
  };
  const getTripulacionViaje = async (id_viaje) => {
    let resp = await axiosHelper({
      url: "tripulacion/viaje/" + id_viaje,
    });

    return resp;
  };
  const putUnidadNegocio = async (negocio_id) => {
    let resp = await axiosHelper({
      url: "login/change-negocio",
      data: { negocio_id },
      method: "put",
    });

    return resp;
  };
  const postTripulanteViaje = async (data) => {
    let resp = await axiosHelper({
      url: "tripulacion/tripulante-viaje",
      data: data,
      method: "post",
    });

    return resp;
  };
  const postDenegacionViaje = async (data) => {
    let resp = await axiosHelper({
      url: "denegaciones-viaje",
      data: data,
      method: "post",
    });

    return resp;
  };

  const postViaje = async (viaje = viajeModel) => {
    let resp = await axiosHelper({
      url: "viajes",
      data: viaje,
      method: "post",
    });
    return resp;
  };

  const putViaje = async (viaje = viajeExistModel) => {
    let resp = await axiosHelper({
      url: "viajes",
      data: viaje,
      method: "put",
    });
    return resp;
  };

  const putViajev2 = async (viaje = viajeExistModel) => {
    let resp = await axiosHelper({
      url: "v2/viajes",
      data: viaje,
      method: "put",
    });
    return resp;
  };

  const putViajeStatus = async (viaje_id, status_id) => {
    let resp = await axiosHelper({
      url: "viajes/status",
      data: { viaje_id, status_id },
      method: "put",
    });
    return resp;
  };

  //v2 cambiar estatus
  const putViajeStatusV2 = async (viaje_id, status_id) => {
    let resp = await axiosHelper({
      url: "v2/viajes/status",
      data: { viaje_id, status_id },
      method: "put",
    });
    return resp;
  };

  const getCheckPruebaViaje = async (id_viaje) => {
    let resp = await axiosHelper({
      url: "checkPrueba/" + id_viaje,
    });
    return resp;
  };

  const postCheckPrueba = async (checkPrueba = checkModel) => {
    let resp = await axiosHelper({
      url: "checkPrueba",
      data: checkPrueba,
      method: "post",
    });
    return resp;
  };

  const postTipulantes = async (tripulantes = tripulantesModel) => {
    let resp = await axiosHelper({
      url: "tripulacion",
      data: tripulantes,
      method: "post",
    });
    return resp;
  };

  const deleteTipulantes = async (idTripulacion = 0) => {
    let resp = await axiosHelper({
      url: "tripulacion/" + idTripulacion,
      method: "delete",
    });
    return resp;
  };
  const deleteTripulacionViaje = async (idViaje = 0) => {
    let resp = await axiosHelper({
      url: "tripulacion/viaje/" + idViaje,
      method: "delete",
    });
    return resp;
  };

  const createRutas = async (rutas = ModelRutas) => {
    let resp = await axiosHelper({
      url: "rutas/createRutas",
      method: "post",
      data: rutas,
    });

    return resp;
  };
  const createRuta = async (ruta = ModelRuta) => {
    let resp = await axiosHelper({
      url: "rutas/createRuta",
      method: "post",
      data: ruta,
    });
    return resp;
  };

  const deleteRuta = async (idRuta = 0) => {
    let resp = await axiosHelper({
      url: "rutas/" + idRuta,
      method: "delete",
    });
    return resp;
  };

  const getViajeUnidad = async (unidad_id) => {
    let resp = await axiosHelper({
      url: "viajes/unidad/" + unidad_id,
    });
    return resp;
  };

  const getViajeFlujo = async (viaje_id) => {
    let resp = await axiosHelper({
      url: "viajes/flujos/" + viaje_id,
    });
    return resp;
  };

  const getViaje = async (viaje_id) => {
    let resp = await axiosHelper({
      url: "viajes/" + viaje_id,
    });
    return resp;
  };

  const getViajes = async () => {
    let resp = await axiosHelper({
      url: "viajes",
    });
    return resp;
  };

  const getTripulacion = async () => {
    let resp = await axiosHelper({
      url: "tripulacion",
    });


    return resp;
  };
  const getOperadorCedis = async (id_cedis) => {
    let resp = await axiosHelper({
      url: "choferes/cedis/" + id_cedis,
    });
    return resp;
  };
  const getTiendasCedis = async (hub_id) => {
    let resp = await axiosHelper({
      url: "tiendas/hub/" + hub_id,
    });
    return resp;
  };

  const getTiendasHub = async (hubs_id) => {
    let resp = await axiosHelper({
      url: "tiendas/hub/" + hubs_id,
    });

    return resp;
  };
  const getUnidad = async (id_unidad) => {
    let resp = await axiosHelper({
      url: "unidades/" + id_unidad,
    });
    return resp;
  };
  const getUnidades = async () => {
    let resp = await axiosHelper({
      url: "unidades",
    });
    return resp;
  };

  const getunidadesNegocio = async (idNegocio, tipoUnidadId) => {
    const url = `unidades/negocio?idNegocio=${idNegocio}&tipo_unidad_id=${tipoUnidadId}`
    let resp = await axiosHelper({
      url: url,
    });
    return resp;
  }

  const getUnitsBusqueda = async (busqueda, idNegocio = null) => {
    let cUrl = `unidades?busqueda=${busqueda}`;

    if (idNegocio !== undefined && idNegocio !== null && idNegocio !== "") {
      cUrl += `&idNegocio=${idNegocio}`;
    }

    let resp = await axiosHelper({
      url: cUrl,
    });
    return resp;
  };

  const getUnits = async () => {
    let resp = await axiosHelper({
      url: "unidades",
    });
    return resp;
  };

  const getUnidadesByHub = async (hubs_id) => {
    let resp = await axiosHelper({
      url: "unidades/hub/" + hubs_id,
    });
    return resp;
  };

  const deleteUnidad = async (unidad_id, activo) => {
    let resp = await axiosHelper({
      method: "put",
      url: "unidades/status/" + unidad_id,
      data: activo,
    });
    return resp;
  };

  const postBitacora = async (bitacora = ModelBitacora) => {
    let resp = await axiosHelper({
      url: "bitacora",
      method: "post",
      data: bitacora,
    });
    return resp;
  };
  const getOperadorViaje = async (id_viaje) => {
    let resp = await axiosHelper({
      url: "choferes/viaje/" + id_viaje,
    });
    return resp;
  };

  // const putViajeRegreso = async (viaje_id) => {
  //   //
  //   var data = JSON.stringify({
  //     viaje_id: viaje_id,
  //     status: 7,
  //   });

  //   let resp = await axiosHelper({
  //     url: "viajes/status",
  //     method: "put",
  //     data: data,
  //   });
  //   return resp;
  // };
  const getListaEstatus = async () => {
    let resp = await axiosHelper({
      url: "estatus",
    });

    return resp;
  };

  const getListaCedis = async () => {
    let resp = await axiosHelper({
      url: "cedis",
    });

    return resp;
  };

  const getChoferes = async () => {
    let resp = await axiosHelper({
      url: "choferes",
    });

    return resp;
  };

  const getUnidadesDinamicas = async () => {
    let resp = await axiosHelper({
      url: "bitacora/unidades-dinamicas",
    });

    return resp;
  };

  const getTiposMovimientos = async () => {
    let resp = await axiosHelper({
      url: "estatus/tipos-movimientos",
    });

    return resp;
  };
  const postEstatus = async (status) => {
    let resp = await axiosHelper({
      url: "estatus",
      method: "post",
      data: status,
    });
    return resp;
  };
  const putEstatus = async (status) => {
    let resp = await axiosHelper({
      url: "estatus/" + status.id,
      method: "put",
      data: status,
    });
    return resp;
  };
  const postUsuariosCedis = async (data) => {
    let resp = await axiosHelper({
      url: "users-cedis/",
      method: "post",
      data: data,
    });
    return resp;
  };
  const deleteUsuariosCedisByUserId = async (userId) => {
    let resp = await axiosHelper({
      url: "users-cedis/user/" + userId,
      method: "delete",
    });
    return resp;
  };
  const getUsuariosCedisByUserId = async (userId) => {
    let resp = await axiosHelper({
      url: "users-cedis/" + userId,
      method: "get",
    });
    return resp;
  };
  const getStatusById = async (id) => {
    let resp = await axiosHelper({
      url: "estatus/" + id,
    });

    return resp;
  };

  const postChofer = async (chofer) => {
    let resp = await axiosHelper({
      url: "choferes",
      method: "post",
      data: chofer,
    });
    return resp;
  };
  const putchofer = async (chofer) => {
    let resp = await axiosHelper({
      url: "choferes/" + chofer.tripulante_id,
      method: "put",
      data: chofer,
    });
    return resp;
  };

  const postCedi = async (cedi) => {
    let resp = await axiosHelper({
      url: "cedis",
      method: "post",
      data: cedi,
    });
    return resp;
  };
  const putCedi = async (cedi) => {
    let resp = await axiosHelper({
      url: "cedis/" + cedi.id,
      method: "put",
      data: cedi,
    });
    return resp;
  };
  const getTripulante = async (id) => {
    let resp = await axiosHelper({
      url: "tripulantes/" + id,
    });
    return resp;
  };

  //v2 tripulante
  const getTripulantev2 = async (id) => {
    let resp = await axiosHelper({
      url: "v2/tripulantes/" + id,
    });
    return resp;
  };

  const postManiobrista = async (maniobrista) => {
    let resp = await axiosHelper({
      url: "tripulacion/maniobrista",
      method: "post",
      data: maniobrista,
    });
    return resp;
  };
  const putManiobrista = async (maniobrista) => {
    let resp = await axiosHelper({
      url: "tripulacion/maniobrista/" + maniobrista.tripulante_id,
      method: "put",
      data: maniobrista,
    });
    return resp;
  };

  const postUnidad = async (unidad) => {
    let resp = await axiosHelper({
      url: "unidades",
      method: "post",
      data: unidad,
    });
    return resp;
  };

  const putUnidad = async (unidad_id, unidad) => {
    let resp = await axiosHelper({
      url: "unidades/" + unidad_id,
      method: "put",
      data: unidad,
    });
    return resp;
  };

  const getUsuarios = async () => {
    let resp = await axiosHelper({
      url: "users",
    });
    return resp;
  };

  const getUsuario = async (id) => {
    let resp = await axiosHelper({
      url: "users/" + id,
    });
    return resp;
  };

  const putUsuario = async (usuario) => {
    let resp = await axiosHelper({
      url: "users/" + usuario.id,
      method: "put",
      data: usuario,
    });
    return resp;
  };

  const postUsuario = async (usuario) => {
    let resp = await axiosHelper({
      url: "users",
      method: "post",
      data: usuario,
    });
    return resp;
  };

  const deleteUser = async (data) => {
    let resp = await axiosHelper({
      url: "users/estatus",
      data: data,
      method: "post",
    });
    return resp;
  };

  const getRoles = async () => {
    let resp = await axiosHelper({
      url: "roles",
    });
    return resp;
  };

  const getTienda = async (tienda_id) => {
    let resp = await axiosHelper({
      url: "tiendas/" + tienda_id,
    });
    return resp;
  };

  const putTienda = async (tienda) => {
    let resp = await axiosHelper({
      url: "tiendas/" + tienda.tienda_id,
      method: "put",
      data: tienda,
    });
    return resp;
  };

  const postTienda = async (tienda) => {
    let resp = await axiosHelper({
      url: "tiendas",
      method: "post",
      data: tienda,
    });
    return resp;
  };
  const getInfoTableroGerencial = async () => {
    let resp = await axiosHelper({
      url: "cedis/tablero/gerencial",
    });

    return resp;
  };
  const getInfoTableroGerencialNegocio = async () => {
    let resp = await axiosHelper({
      url: "negocios/tablero/gerencial",
    });

    return resp;
  };

  const getLogHistorico = async () => {
    let resp = await axiosHelper({
      url: "logsBot",
    });
    return resp;
  };

  const getNotiBotTerminadas = async () => {
    let resp = await axiosHelper({
      url: "logsBot/acciones-pendientes",
    });
    return resp;
  };

  const postWhatsLog = async (data) => {
    let resp = await axiosHelper({
      url: "logsBot",
      data: data,
      method: "post",
    });
    return resp;
  };

  const putNotificaBot = async (id_respuesta, approbe) => {
    let resp = await axiosHelper({
      url: "logsBot",
      data: {
        id: id_respuesta,
        solicitudAprobado: approbe,
      },
      method: "put",
    });
    return resp;
  };

  const getTiendasNegocio = async (negocio_id) => {
    let resp = await axiosHelper({
      url: "tiendas/negocio/" + negocio_id,
    });
    return resp;
  };

  const postRegistroHorario = async (data) => {
    let resp = await axiosHelper({
      url: "registro-horario",
      data: data,
      method: "post",
    });
    return resp;
  };

  const postReporteMonitoristas = async (data) => {
    let resp = await axiosHelper({
      url: "registro-horario/registros_usuarios",
      data: data,
      method: "post",
    });
    return resp;
  };

  const postReporteMonitorista = async (data) => {
    let resp = await axiosHelper({
      url: "registro-horario/registros_usuarios",
      data: data,
      method: "post",
    });
    return resp;
  };

  const getRegistroEventos = async (id_usuario) => {
    let resp = await axiosHelper({
      url: "registro-horario/" + id_usuario,
    });
    return resp;
  };

  const cerrarSesion = async (id) => {
    let resp = await axiosHelper({
      url: "login/cerrar-sesion/" + id,
    });
    return resp;
  };

  const getMonitoristas = async () => {
    let resp = await axiosHelper({
      url: "users/estatus/monitoristas",
    });
    return resp;
  };

  const getUnidadesEnRutaEkt = async (cedis_id) => {
    let resp = await axiosHelper({ url: "unidades/enRuta/ekt/" + cedis_id });
    return resp;
  };

  const getTiposAlmacen = async () => {
    let resp = await axiosHelper({
      url: "almacenes/",
    });
    return resp;
  };

  const getUnidadesByAlmacen = async (cat_tipos_almacen_id) => {
    let resp = await axiosHelper({
      url: "unidades/almacen/" + cat_tipos_almacen_id,
    });
    return resp;
  };

  const getListViajesAutomaticos = async (cedis_id) => {
    let resp = await axiosHelper({
      url: "viajes-automaticos/" + cedis_id,
    });
    return resp;
  };

  const getViajeAutomatico = async (id) => {
    let resp = await axiosHelper({
      url: "viajes-automaticos/unidad/" + id,
    });
    return resp;
  };

  const postViajesAutomaticos = async (data) => {
    let resp = await axiosHelper({
      url: "viajes-automaticos/",
      data: data,
      method: "post",
    });
    return resp;
  };

  const postViajesAutomaticosV2 = async (data) => {
    let resp = await axiosHelper({
      url: "v2/viajes-automaticos/",
      data: data,
      method: "post",
    });
    return resp;
  };

  const getListTripulantesByHub = async (cedis_id, tripulante_id) => {
    let resp = await axiosHelper({
      url: "tripulantes/" + cedis_id + "/" + tripulante_id,
    });
    return resp;
  };

  const putReasignarUnidad = async (id_unidad) => {
    let resp = await axiosHelper({
      url: "viajes-automaticos/" + id_unidad,
      method: "put",
    });
    return resp;
  };

  // const getTripulantes = async (tipo_tripulante_id) => {
  //   let resp = await axiosHelper(
  //     tipo_tripulante_id
  //       ? { busqueda: tipo_tripulante_id, url: "tripulantes" }
  //       : { url: "tripulantes" }
  //   );
  //   return resp;
  // };

  const getTripulantes = async (tipo_tripulante_id, negocio_id = null) => {
    let url = "tripulantes"
    if (negocio_id !== undefined && negocio_id !== null && negocio_id !== "") {
      url += `&negocioId=${negocio_id}`;
    }
    let resp = await axiosHelper(
      tipo_tripulante_id
        ? { busqueda: tipo_tripulante_id, url }
        : { url }
    );
    return resp;
  };

  const postTripulantes = async (data) => {
    let resp = await axiosHelper({
      url: "tripulantes",
      method: "post",
      data: data,
    });
    return resp;
  };

  const putTripulantes = async (id, data) => {
    let resp = await axiosHelper({
      url: "tripulantes/" + id,
      method: "put",
      data: data,
    });
    return resp;
  };

  const bajaTipulante = async (id) => {
    let resp = await axiosHelper({
      url: "tripulantes/" + id,
      method: "delete",
    });
    return resp;
  };

  const actualizarTripulante = async (id, data) => {
    let resp = await axiosHelper({
      url: "tripulantes/estatus/" + id,
      method: "put",
      data,
    });
    return resp;
  };

  const postContingencia = async (data) => {
    let resp = await axiosHelper({
      url: "contingencia",
      method: "post",
      data: data,
    });
    return resp;
  };

  const postCodigos = async (data) => {
    let resp = await axiosHelper({
      url: "codigos/bitacora",
      method: "post",
      data: data,
    });
    return resp;
  };

  const postCodigosToken = async (data) => {
    let resp = await axiosHelper({
      url: "codigos/token",
      method: "post",
      data: data,
    });
    return resp;
  };

  const putListResetCodigos = async (economico) => {
    let resp = await axiosHelper({
      url: "contingencia/" + economico,
      method: "put",
    });
    return resp;
  };

  const getNegocioContingencia = async (id) => {
    let resp = await axiosHelper({
      url: "negocios/" + id,
    });
    return resp;
  };

  const actualizarNumCodigos = async (id, data) => {
    let resp = await axiosHelper({
      url: "negocios/" + id,
      method: "put",
      data,
    });
    return resp;
  };

  const getReporteViajes = async () => {
    let resp = await axiosHelper({
      url: "reportViajes",
    });
    return resp;
  };

  const getReporteViajesAlmacenes = async () => {
    let resp = await axiosHelper({
      url: "reportViajes/almacenes",
    });
    return resp;
  };

  const getReporteFiltroViajes = async (data) => {
    let resp = await axiosHelper({
      url: "reportViajes/getViaje",
      method: "post",
      data,
    });
    return resp;
  };

  const putReporteViaje = async (id, data) => {
    let resp = await axiosHelper({
      url: "reportViajes/" + id,
      method: "delete",
    });
    return resp;
  };

  const estatusContingencia = async () => {
    let resp = await axiosHelper({
      url: "contingencia",
    });
    return resp;
  };

  const activarContingenciaNegocios = async (accion) => {
    let resp = await axiosHelper({
      url: "contingencia/accion/" + accion,
    });
    return resp;
  };

  const postRegistroEventoSeguridad = async (data) => {
    let resp = await axiosHelper({
      url: "registro-seguridad",
      method: "post",
      data: data,
    });
    return resp;
  };

  const putRegistroEventoSeguridad = async (data, evento_seguridad_id) => {
    let resp = await axiosHelper({
      url: "registro-seguridad/" + evento_seguridad_id,
      method: "put",
      data: data,
    });
    return resp;
  };

  const deleteRegistroEventoSeguridad = async (evento_seguridad_id) => {
    let resp = await axiosHelper({
      url: "registro-seguridad/" + evento_seguridad_id,
      method: "delete",
    });
    return resp;
  };

  const postEventoSeguridad = async (data) => {
    let resp = await axiosHelper({
      url: "eventos-seguridad",
      method: "post",
      data: data,
    });
    return resp;
  };

  const getEventos = async () => {
    let resp = await axiosHelper({
      url: "eventos",
    });
    return resp;
  };

  const getStatusEvento = async () => {
    let resp = await axiosHelper({
      url: "estatus-eventos",
    });
    return resp;
  };

  const getRegistroSeguridadEventos = async (pendientes) => {
    let resp = await axiosHelper({
      url: "registro-seguridad",
      pendientes: pendientes,
    });
    return resp;
  };

  const getRegistroSeguridadEventosFinalizados = async (finalizado) => {
    let resp = await axiosHelper({
      url: "registro-seguridad",
      finalizado: finalizado,
    });
    return resp;
  };

  const getRegistroSeguridadEventosv2 = async (
    numeroPagina,
    finalizado,
    fecha
  ) => {
    let url = `v2/registro-seguridad?numeroPagina=${numeroPagina}`;

    if (finalizado !== undefined && finalizado !== null && finalizado !== "") {
      url += `&finalizado=${finalizado}`;
    }

    if (fecha) {
      url += `$fecha=${fecha}`;
    }

    let resp = await axiosHelper({ url });
    return resp;
  };

  const getRegistroSeguridadEventosByDate = async (fechaInicio, fechaFinal) => {
    let resp = await axiosHelper({
      url: "registro-seguridad?fecha_inicio=" + fechaInicio + "&fecha_fin=" + fechaFinal,
    });
    return resp;
  };

  const getExisteEventoRobo = async (evento_seguridad_id, tipo) => {
    let resp = await axiosHelper({
      url: "registro-seguridad/" + evento_seguridad_id + "?tipo=" + tipo,
    });
    return resp;
  };

  const postFilesUploads = async (data, id_evento) => {
    let resp = await axiosHelper({
      url: "eventos-seguridad/uploads/" + id_evento,
      method: "post",
      data: data,
      file: true,
    });
    return resp;
  };

  const postNegocios = async (data) => {
    let resp = await axiosHelper({
      url: "negocios",
      method: "post",
      data: data,
      file: true,
    });
    return resp;
  };

  const getEventoSeguridadId = async (id_evento) => {
    let resp = await axiosHelper({
      url: "eventos-seguridad/" + id_evento,
      eventoseguridad: true,
    });
    return resp;
  };

  const patchEventoSeguridadId = async (id, data) => {
    let resp = await axiosHelper({
      url: `eventos-seguridad/${id}`,
      method: "patch",
      data: data,
    });
    return resp;
  };

  const getTipoApoyo = async () => {
    let resp = await axiosHelper({
      url: "apoyo-tipo",
    });

    return resp;
  };

  const getFile = async (registro_evento_id) => {
    let resp = await axiosHelper({
      url: "eventos-seguridad/download/" + registro_evento_id,
    });

    return resp;
  };

  const getEntidadesFederativas = async () => {
    let resp = await axiosHelper({
      url: "entidades-federativas",
    });
    return resp;
  };

  const getMunicipiosId = async (id) => {
    let resp = await axiosHelper({
      url: "municipios/" + id,
    });
    return resp;
  };

  const getNegocioImagen = async (id) => {
    let resp = await axiosHelper({
      url: "negocios/" + id + "bg",
    });
    return resp;
  };

  const getTiposVehiculos = async () => {
    let resp = await axiosHelper({
      url: "vehiculos-tipos",
    });
    return resp;
  };

  const postVehiculos = async (data) => {
    let resp = await axiosHelper({
      url: "vehiculos",
      method: "post",
      data: data,
    });
    return resp;
  };

  const getUnidadesTipo = async (tipo_unidad_id, page, limit) => {
    let resp = await axiosHelper({
      url: `vehiculos?page=${page}&limit=${limit}&tipo_unidad_id=${tipo_unidad_id}`,
    });
    return resp;
  };

  const putActUnidadesAutosMotos = async (data, id_unidad) => {
    let resp = await axiosHelper({
      url: "vehiculos/" + id_unidad,
      method: "put",
      data: data,
    });
    return resp;
  };

  const getUnidadTipoId = async (tipo_unidad_id, id_unidad) => {
    let resp = await axiosHelper({
      url: `vehiculos/${id_unidad}?tipo_unidad_id=${tipo_unidad_id}`,
    });
    return resp;
  };

  const getCatalogos = async (tipo) => {
    let resp = await axiosHelper({
      url: `vehiculos/catalogos?tipo=${tipo}`,
    });
    return resp;
  };

  const getSubmarcas = async (marca) => {
    let resp = await axiosHelper({
      url: `vehiculos/catalogos/submarcas/${marca}`,
    });
    return resp;
  };

  const getRegistrosBoletinados = async () => {
    let resp = await axiosHelper({
      url: `registro-seguridad/estatus-evento/10`,
      finalizado: true,
    });
    return resp;
  };

  const patchRegistroSeguridad = async (id) => {
    let resp = await axiosHelper({
      url: `registro-seguridad/${id}`,
      method: "patch",
    });
    return resp;
  };

  const postValidarArchivo = async (data) => {
    let resp = await axiosHelper({
      method: "post",
      url: "eventos-seguridad/validate-file",
      data: data,
      file: true,
    });
    return resp;
  };

  const getVehiculoSearch = async (numeroSerie, tipo_unidad_id, page, limit) => {
    let resp = await axiosHelper({
      url: `vehiculos/buscar-serie?numeroSerie=${numeroSerie}&tipo_unidad_id=${tipo_unidad_id}&page=${page}&limit=${limit}`,
    });
    return resp;
  };

  const getPosition = async (ecoUnidad) => {
    let resp = await axiosHelper({
      url: "unidades/position/" + ecoUnidad,
    });
    return resp;
  };

  const getStatsUnidades = async () => {
    let resp = await axiosHelper({
      url: "stats/units",
    });
    return resp;
  };

  const getPositionCamiones = async (unidad_id) => {
    let resp = await axiosHelper({
      url: "unidades/position/" + unidad_id,
    });
    return resp;
  };

  const ejecutarParoMotor = async (ejecutar, unidad_id) => {
    let resp = await axiosHelper({
      url: `checkPrueba/comandos/paro-motor?toggle=${ejecutar}&unidad_id=${unidad_id}`,
    });
    return resp;
  };

  const getBTNPanico = async (fecha_inicio, fecha_fin, unidad_id) => {
    let resp = await axiosHelper({
      url: `checkPrueba/comandos/boton-panico?fechaInicio=${fecha_inicio}&fechaFin=${fecha_fin}&unidad_id=${unidad_id}`,
    });
    return resp;
  };

  const getCajasSecas = async () => {
    let resp = await axiosHelper({
      url: "cajas-secas",
    });
    return resp;
  };

  const patchEstatus = async (status_id) => {
    let resp = await axiosHelper({
      url: "estatus/" + status_id,
      method: "patch",
    });

    return resp;
  };

  const postProtocolos = async (id) => {
    let resp = await axiosHelper({
      url: "protocolos-seguridad",
      method: "post",
      data: id,
    });
    return resp;
  };

  const putProtocolos = async (protocolo_id, payload) => {
    let resp = await axiosHelper({
      url: "protocolos-seguridad/" + protocolo_id,
      method: "put",
      data: payload,
    });
    return resp;
  };

  const getProtocolos = async (cedis_id) => {
    let resp = await axiosHelper({
      url: "protocolos-seguridad/" + cedis_id,
    });
    return resp;
  };

  const postEscalamiento = async (data) => {
    let resp = await axiosHelper({
      url: "protocolo-escalamiento",
      method: "post",
      data: data,
    });
    return resp;
  };

  const deleteEscalamiento = async (escalamiento_id) => {
    let resp = await axiosHelper({
      url: "protocolo-escalamiento/" + escalamiento_id,
      method: "delete",
    });
    return resp;
  };

  const postGruposChat = async (data) => {
    let resp = await axiosHelper({
      url: "grupos-mensajeria",
      method: "post",
      data: data
    });
    return resp;
  };

  const putGruposChat = async (grupo_mensajeria_id, payload) => {
    let resp = await axiosHelper({
      url: "grupos-mensajeria/" + grupo_mensajeria_id,
      method: "put",
      data: payload,
    });
    return resp;
  };

  const getGruposChat = async (cedis_id) => {
    let resp = await axiosHelper({
      url: "grupos-mensajeria/" + cedis_id,
    });
    return resp;
  };

  const deleteGruposChat = async (grupo_mensajeria_id) => {
    let resp = await axiosHelper({
      url: "grupos-mensajeria/" + grupo_mensajeria_id,
      method: "delete",
    });
    return resp;
  };

  const getTripulantesIdNegocio = async (negocio_id, tipo_tripulante_id) => {
    const resp = await axiosHelper(
      tipo_tripulante_id
        ? { busqueda: tipo_tripulante_id, url: `v2/tripulantes?idNegocio=${negocio_id}` }
        : { url: `v2/tripulantes?idNegocio=${negocio_id}` }
    );
    return resp;
  }

  const getRegistrosSeguridadPage = async (numero_pagina, busqueda = "") => {
    // Construye la URL con los parámetros necesarios
    let url = `v2/registro-seguridad?numeroPagina=${numero_pagina}`;

    // Agrega el parámetro de búsqueda si hay texto
    if (busqueda.trim() !== "") {
      url += `&search=${encodeURIComponent(busqueda)}`;
    }

    // Llama al servicio
    let resp = await axiosHelper({ url });
    return resp;
  };

  const getRegistrosSeguridadPageFinalizados = async (
    numero_pagina = "",
    busqueda = "",
    fecha_inicio = "",
    fecha_fin = ""
  ) => {
    let url = `v2/registro-seguridad?finalizado=1`;
    const params = [];

    if (String(numero_pagina).trim()) {
      params.push(`numeroPagina=${encodeURIComponent(numero_pagina)}`);
    }
    if (String(busqueda).trim()) {
      params.push(`search=${encodeURIComponent(busqueda)}`);
    }
    if (String(fecha_inicio).trim()) {
      params.push(`fecha_inicio=${encodeURIComponent(fecha_inicio)}`);
    }
    if (String(fecha_fin).trim()) {
      params.push(`fecha_fin=${encodeURIComponent(fecha_fin)}`);
    }

    if (params.length > 0) {
      url += `&${params.join("&")}`;
    }

    const resp = await axiosHelper({ url });
    return resp;
  };

  const getSeguimientoRegistrosSeguridad = async (id) => {
    let resp = await axiosHelper({
      url: "v2/registro-seguridad/" + id,
    });
    return resp;
  };

  const getStatsUnidadesBitacora = async (nombre_cedis, status_id = null) => {
    let url = `stats/bitacora-cedis?nombre_cedis=${encodeURIComponent(
      nombre_cedis
    )}`
    if (status_id) {
      url = `stats/bitacora-cedis?status_id=${status_id}&nombre_cedis=${encodeURIComponent(
        nombre_cedis
      )}`
    }
    let resp = await axiosHelper({
      url,
    });
    return resp;
  };

  const putCoordenadas = async (id, payload) => {
    let resp = await axiosHelper({
      url: "bitacora/" + id,
      method: "put",
      data: payload,
    });
    return resp;
  };

  const getStatsSwat = async (fechaI, fechaF, type) => {
    let url = `stats/eventsSecurity?fechaInicio=${fechaI}&fechaFin=${fechaF}`;
    if (type) url = `stats/eventsSecurity?fechaInicio=${fechaI}&fechaFin=${fechaF}&type=${type}`;
    const resp = await axiosHelper({
      url,
    });
    return resp
  }

  const executeAperturaCerradura = async (unidad_id) => {
    let resp = await axiosHelper({
      url: "comandos/aperturaCerradura/" + unidad_id,
      method: "patch",
    });
    return resp;
  };

  const getAperturaCerradura = async (comando_id, unidad_id) => {
    let resp = await axiosHelper({
      url: `comandos/aperturaCerradura?comando_id=${comando_id}&unidad_id=${unidad_id}`,
    });
    return resp;
  };

  const getUnidadesFiltro = async ({ busqueda = null, idNegocio = null, search = "", numeroPagina, arrayCedis = [] }) => {
    let url = `v2/unidades?numeroPagina=${numeroPagina}`;
    const params = [];

    if (String(busqueda).trim()) {
      params.push(`busqueda=${parseInt(busqueda)}`);
    }
    if (idNegocio) {
      params.push(`idNegocio=${parseInt(idNegocio)}`);
    }
    if (String(search).trim()) {
      params.push(`search=${encodeURIComponent(search)}`);
    }

    if (params.length > 0) {
      url += `&${params.join("&")}`;
    }

    const resp = await axiosHelper({ url, method: "POST", data: arrayCedis });
    return resp;
  };

  const putStatusTripulante = async (tripulante_id, data) => {
    let resp = await axiosHelper({
      url: `tripulantes/estatus/${tripulante_id}`,
      method: "put",
      data,
    });
    return resp;
  };

  const putConfirmacionApertura = async (id, data) => {
    let resp = await axiosHelper({
      url: `comandos/aperturaCerradura/${id}`,
      method: "put",
      data,
    });
    return resp;
  };

  const getMdvrsClientes = async () => {
    let resp = await axiosHelper({
      url: `dispositivos/mdvr/catalogo-clientes`,
    });
    return resp;
  };

  const getMdvrsDispositivos = async (numero_pagina = 1, busqueda = "", cliente = "", limit = 7) => {

    let url = `dispositivos/mdvr?numeroPagina=${numero_pagina}&limit=${limit}`;
    const params = [];

    if (String(busqueda).trim()) {
      params.push(`search=${encodeURIComponent(busqueda)}`);
    }

    if (String(cliente).trim()) {
      params.push(`cliente=${encodeURIComponent(cliente)}`)
    }

    if (params.length > 0) {
      url += `&${params.join("&")}`;
    }

    const resp = await axiosHelper({ url });
    return resp;
  };

  const getStatusCamaras = async () => {
    let resp = await axiosHelper({
      url: `catalogo/estatus-dispositivos`,
    });
    return resp;
  };

  const postCheckListMdvr = async (data) => {
    let resp = await axiosHelper({
      url: "checklist/dispositivos",
      method: "post",
      data: data
    });
    return resp;
  };

  const getInfoMdvr = async (id) => {
    let resp = await axiosHelper({
      url: `dispositivos/mdvr/${id}`,
    });
    return resp;
  };

  const postImagenMdvr = async (id, data) => {
    let resp = await axiosHelper({
      url: `checklist/dispositivos/upload-evidence/${id}`,
      method: "post",
      data: data,
      file: true,
    });
    return resp;
  }

  const getCheckListDevice = async (fechaInicial, fechaFinal, cliente) => {
    let url = `checklist/dispositivos?fechaI=${fechaInicial}&fechaF=${fechaFinal}`;
    const params = [];

    if (String(cliente).trim()) {
      params.push(`cliente=${encodeURIComponent(cliente)}`)
    }

    if (params.length > 0) {
      url += `&${params.join("&")}`;
    }

    const resp = await axiosHelper({ url });
    return resp;
  };

  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    }
  );

  const postDownloadEvidence = async (id) => {
    try {
      const url = `${process.env.REACT_APP_API_URL_LOCAL}checklist/dispositivos/download-evidence/${id}`;

      const resp = await axios.post(url, {}, {
        responseType: "blob",
        headers: {
          "x-token": localStorage.getItem("xt"),
        },
      });

      // Cuando NO hay imagen, backend manda JSON
      if (!resp.headers["content-type"]?.includes("image")) {
        return null;
      }

      // 🔑 Retorna en base64
      return await blobToBase64(resp.data);

    } catch (err) {
      console.warn(`Sin imagen para check_id ${id}`);
      return null;
    }
  };

  const getUnidadesSWAT = async (numeroPagina, busqueda = "", idNegocio = null, search = "", arrayCedis = []) => {
    let url = `v2/unidades?numeroPagina=${numeroPagina}`;
    const params = [];

    if (String(busqueda).trim()) {
      params.push(`busqueda=${parseInt(busqueda)}`);
    }
    if (idNegocio) {
      params.push(`idNegocio=${parseInt(idNegocio)}`);
    }
    if (String(search).trim()) {
      params.push(`search=${encodeURIComponent(search)}`);
    }

    if (params.length > 0) {
      url += `&${params.join("&")}`;
    }

    const resp = await axiosHelper({ url, method: "POST", data: arrayCedis});
    return resp;
  };

  const postRegistroEventoSeguridadV2 = async (data) => {
    let resp = await axiosHelper({
      url: "v2/registro-seguridad",
      method: "post",
      data: data
    });
    return resp;
  };

  const postViajeV2 = async (data) => {
    let resp = await axiosHelper({
      url: "v2/viajes",
      method: "post",
      data: data,
    });
    return resp;
  };

  return {
    getStatsSwat,
    getUnidadesFormatoSalida,
    getUnidadesEnRuta,
    getTiendasViaje,
    getTripulacionViaje,
    postViaje,
    putViaje,
    getCheckPruebaViaje,
    postCheckPrueba,
    postTipulantes,
    deleteTipulantes,
    createRutas,
    createRuta,
    deleteRuta,
    getChoferesCedisId,
    getChoferes,
    getViajeUnidad,
    getTripulacion,
    getOperadorCedis,
    getTiendasCedis,
    getTiendasHub,
    getUnidad,
    getUnidades,
    getUnits,
    getUnitsBusqueda,
    getUnidadesByHub,
    deleteUnidad,
    putViajeStatus,
    getBitacoraViaje,
    postBitacora,
    getOperadorViaje,
    getListaEstatus,
    getBitacoras,
    getListaCedis,
    getUnidadesDinamicas,
    postEstatus,
    getTiposMovimientos,
    putEstatus,
    getStatusById,
    getChofer,
    postChofer,
    putchofer,
    getTripulante,
    getTripulantev2,
    postManiobrista,
    putManiobrista,
    getCedi,
    getCedis,
    postCedi,
    putCedi,
    postUnidad,
    putUnidad,
    getUsuario,
    getUsuarios,
    putUsuario,
    postUsuario,
    deleteUser,
    getRoles,
    getTienda,
    deleteTripulacionViaje,
    postTienda,
    putTienda,
    getTiendasNegocio,
    postUsuariosCedis,
    deleteUsuariosCedisByUserId,
    getUsuariosCedisByUserId,
    postTripulanteViaje,
    postDenegacionViaje,
    getNegocios,
    getCedisNegocios,
    getViaje,
    getInfoTableroGerencial,
    getInfoTableroGerencialNegocio,
    getCedisNegociosAll,
    getBitacoraAdministracion,
    putUnidadNegocio,
    getNotiBotTerminadas,
    getLogHistorico,
    postWhatsLog,
    putNotificaBot,
    postRegistroHorario,
    getRegistroEventos,
    cerrarSesion,
    getMonitoristas,
    postReporteMonitoristas,
    postReporteMonitorista,
    getUnidadesEnRutaEkt,
    getTiposAlmacen,
    getUnidadesByAlmacen,
    getListViajesAutomaticos,
    getListTripulantesByHub,
    postViajesAutomaticos,
    putReasignarUnidad,
    getViajeFlujo,
    getTripulantes,
    actualizarTripulante,
    bajaTipulante,
    putTripulantes,
    postTripulantes,
    postContingencia,
    postCodigos,
    getNegocioContingencia,
    actualizarNumCodigos,
    getReporteViajes,
    getReporteViajesAlmacenes,
    getReporteFiltroViajes,
    putReporteViaje,
    estatusContingencia,
    activarContingenciaNegocios,
    postRegistroEventoSeguridad,
    postEventoSeguridad,
    putRegistroEventoSeguridad,
    getEventos,
    getStatusEvento,
    getExisteEventoRobo,
    postFilesUploads,
    deleteRegistroEventoSeguridad,
    getTipoApoyo,
    getRegistroSeguridadEventos,
    getEventoSeguridadId,
    getFile,
    getEntidadesFederativas,
    getMunicipiosId,
    getRegistroSeguridadEventosByDate,
    getRegistroSeguridadEventosFinalizados,
    postCodigosToken,
    getViajeAutomatico,
    postNegocios,
    getNegocioImagen,
    putListResetCodigos,
    getTiposVehiculos,
    postVehiculos,
    getUnidadesTipo,
    putActUnidadesAutosMotos,
    getUnidadTipoId,
    getCatalogos,
    getSubmarcas,
    getRegistrosBoletinados,
    patchRegistroSeguridad,
    getPosition,
    getPositionCamiones,
    postValidarArchivo,
    getVehiculoSearch,
    getStatsUnidades,
    ejecutarParoMotor,
    getBTNPanico,
    getCajasSecas,
    patchEstatus,
    getViajes,
    postProtocolos,
    putProtocolos,
    getProtocolos,
    postEscalamiento,
    deleteEscalamiento,
    postGruposChat,
    putGruposChat,
    getGruposChat,
    deleteGruposChat,
    getStatsUnidadesBitacora,
    getRegistroSeguridadEventosv2,
    getTripulantesIdNegocio,
    putViajeStatusV2,
    getBitacorasV2,
    getRegistrosSeguridadPage,
    patchEventoSeguridadId,
    getSeguimientoRegistrosSeguridad,
    getRegistrosSeguridadPageFinalizados,
    putCoordenadas,
    getunidadesNegocio,
    executeAperturaCerradura,
    getAperturaCerradura,
    getUnidadesFiltro,
    putStatusTripulante,
    putConfirmacionApertura,
    getMdvrsClientes,
    getMdvrsDispositivos,
    getStatusCamaras,
    postCheckListMdvr,
    getInfoMdvr,
    postImagenMdvr,
    getCheckListDevice,
    postDownloadEvidence,
    getUnidadesSWAT,
    postRegistroEventoSeguridadV2,
    postViajeV2,
    postViajesAutomaticosV2,
    putViajev2,
  };
};
